import { FourOhThree } from '@brighterionai/br-ui';
import React from 'react';
import { APPLICATION_ACCESS_PENDING, PLEASE_CONSULT_ADMIN } from '../../utils/constants';
import Navigation from '../Navigation/Navigation';

const AccessPending: React.FC = () => {
    const customTextFunc = (str: string) => {
        switch (str) {
            case '403 - Forbidden':
                return APPLICATION_ACCESS_PENDING;
            case 'Access was denied. You do not have permission to access the requested resource. Please ':
                return PLEASE_CONSULT_ADMIN;
            case 'log out':
                return '';
            case ' and contact the administrator to correct the issue.':
                return '';
            default:
                return str;
        }
    };

    return (
        <>
            <Navigation
                options={{
                    isMastercardConnectUser: false
                }}
            />
            <FourOhThree onLinkClick={() => {}} tFunc={customTextFunc} />
        </>
    );
};

export default AccessPending;
